export const words = {
  place: "Umiestnenie",
  yes: "Áno",
  no: "Nie",
  new: "Nový",
  agb: 'AGB',
  agb_full: "Všeobecné podmienky",
  datenschutzerklaerung: "Zásady ochrany osobných údajov",
  status: "Stav",
  company_name: "Názov spoločnosti",
  next_button: "Ďalšie informácie na",
  device_name: "Názov zariadenia",
  to_connect: "Pripojenie",
  pin: 'PIN',
  time: "Čas",
  first_name: "Krstné meno",
  last_name: "Priezvisko",
  code: "Kód",
  help: "Pomoc",
  total_time: "Celkový čas",
  latitude: "Zemepisná šírka",
  longitude: "Zemepisná dĺžka",
  accuracy: "Presnosť",
  timestamp: "Časová pečiatka",
  device_id: "ID zariadenia",
  active: "aktívny",
  o_clock: "Hodiny",
  loading: "Obchod",
  annotation: "Poznámka",
  since: "od",
  camera: "Fotoaparát",
  map: "Mapa",
  gallery: "Galéria",
  work: "Práca",
  employees: "Zamestnanci",
  login: "Registrácia",
  login_action: "Prihlásiť sa",
  calendar_week_abbreviation: 'KW',
  calendar: "Kalendár",
  to_call: "Zavolajte na",
  email: "E-mail",
  attachment: "Príloha",
  operational_planning: "Operačný plán",
  to_scan: "Skenovanie",
  download: "Stiahnite si",
  export: "Export",
  to_document: "Dokument",
  checklist: "Kontrolný zoznam",
  checklists: "Kontrolné zoznamy",
  password: "Heslo",
  confirmation: "Potvrdenie",
  confirm: "Potvrďte",
  confirmation_email: "Potvrdzujúci e-mail",
  unknown: "Neznámy",
  unknown_place: "Neznáma poloha",
  unknown_plan: "Nemenovaný rozvrh zmien",
  project_no: "Projekt č.",
  project_file: "Súbor projektu",
  contact_person: "Kontakt",
  overtime: "Nadčasy",
  timesheet: "Rozvrh hodín",
  minustime: "Mínus hodín",
  back: "Späť",
  undo: "Zrušiť",
  clockout: "Vytlačiť pečiatku",
  clocked_out: "vyrazené",
  clockin: "Pečiatka v",
  clocked_in: "vyrazené",
  dismiss: "Zrušiť",
  discard: "Odmietnuť",
  finish: "Pripravené",
  or: "alebo",
  copy: "Kopírovať",
  qr_code: "Kód QR",
  documentation: "Zaznamenávanie času a dokumentácia",
  attendance: "Terminál pre tablety",
  tiercontent: "Rozsah balenia",
  start_now: "Začnite hneď teraz",
  skip: "preskočiť",
  logout_during_core_time: "Vyrazené počas základného času",
  absent_during_core_time: "Chýba počas základného času",
  distance: "Vzdialenosť",
  km_reading: "Počet najazdených kilometrov",
  the_start: "Štart",
  the_end: "Koniec",
  license_plate: "Tabuľka s evidenčným číslom",
  details: "Podrobnosti",
  hide: "skryť",
  cost: "Náklady",
  file: "Súbor",
  address_book: "Adresár",
  template_plural: "Šablóny",
  signature: "Podpis",
  main_project: "Hlavný projekt",
  main_projects: "Hlavné projekty",
  sub_projects: "Podprojekty",
  scan_to_login_header: "Registrácia kódu QR",
  description: "Popis",
  project_location: "Umiestnenie projektu",
  phone_number: "Telefónne číslo",
  project_info: "Informácie o projekte",
  number_short: "Nie.",
  sketch: "Náčrt",
  video: 'Video',
  delete: "Odstrániť",
  send: "Odoslať",
  sending: "Poslať...",
  save: "Uložiť",
  granted: "schválené",
  pending: "požadované",
  denied: "Odmietnuté",
  customer: "Zákazník",
  mobile_number: "Telefónne číslo",
  ok: 'Ok',
  day: "Deň",
  tomorrow: "Ráno",
  days: "Dni | Deň | Dni",
  holidays: "Dovolenka",
  vacation_days: "Dovolenka",
  vacation_hours: "Prázdninové hodiny",
  request: "Žiadosť",
  accept: "Prijať",
  withdraw: "Stiahnuť",
  hour_account: "Hodinový účet",
  period: "Obdobie",
  to: "na",
  date: "Menovanie",
  number: "Číslo",
  message: "Správa",
  change: "zmeniť",
  changed: "Zmenený",
  changed_fields: "Zmenené polia",
  type: 'Art',
  hour: "Hodina",
  hours: "Hodiny",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Hodiny",
  end: "koniec",
  end_date: "Termín",
  start_date: "Dátum začiatku",
  absence: "Neprítomnosť",
  month: "mesiac",
  week: "Týždeň",
  transcript: "Prepis",
  time_left: "zvyšný",
  transcript_tasks: "Úlohy",
  add_task: "Nový",
  /** Differentiation in some languages (e.g. English) */
  from: "z adresy",
  of: "z adresy",
  of_hours: "od {hours} hodín",
  of_hours_abbreviation: "{hours} z hodín.",
  /**************/

  used: "použité",
  update: "Aktualizácia",
  today: "dnes",
  correction: "Oprava",
  work_time: "Pracovný čas",
  break: "Prestávka",
  loading_time: "Čas načítania",
  driving_time: "Čas cesty",
  business_trip: "Služobná cesta",
  project: 'Projekt',
  special_one: "Špeciálne1",
  special_two: "Špeciálne2",
  clock: "Hodiny",
  search: "Vyhľadávanie",
  operation: "Aktivita",
  day_protocol: "Denný protokol",
  continue: "viac",
  total_duration: "Celkový čas",
  duration: "Trvanie",
  hello: "Dobrý deň,",
  close: "zavrieť",
  comment: "Komentár",
  small: "malé",
  medium: "stredná",
  large: "veľké",
  sharpie: "Pin",
  line: "Riadok",
  arrow: "Šípky",
  rectangle: "Obdĺžnik",
  ellipse: "Elipsa",
  text: 'Text',
  language_settings: "Nastavenia jazyka",
  clock_reminder: "Pripomienka známky",
  individually: "Jedinec",
  from_o_clock: "z adresy",
  to_o_clock: "na",
  eraser: "Guma",
  edit: "Upraviť",
  legal_notes: "Právna stránka",
  notes: "Poznámky",
  note: "Poznámka",
  imprint: "Odtlačok",
  open_source_licenses: "Licenčné podmienky pre otvorený zdrojový kód",
  author: 'Autor',
  license_type: "Typ licencie",
  version: "Verzia",
  substitute: "Zastúpenie",
  not_rated: "Nehodnotené",
  weekly_working_hours: "Týždenný pracovný čas",
  show_less: "Zobraziť menej",
  office_center: "Centrum kancelárií",
  admin_view: "Správa NFC",
  register: "Zaregistrovať sa",
  shifts: {
    shift_attachments: "Prílohy (vrstva)",
    shift_plan_attachments: "Prílohy (zmenový plán)",
    shift_plan: "Rozvrh zmien",
    shift: "Vrstva"
  },
  absences: {
    sick: "Nemoc (pokračovanie vyplácania mzdy)",
    vacation: "Dovolenka",
    workshop: "Seminár/kurz",
    special_vacation: "Osobitná dovolenka",
    school: "Škola",
    working_time_account: "Účet pracovného času",
    holiday: "Dovolenka",
    other: "Iné",
    driving_time: "Čas cesty",
    parental_leave: "Rodičovská dovolenka",
    excused_absent: "Ospravedlnená neprítomnosť (platená)",
    not_excused_absent: "Neprítomnosť bez ospravedlnenia",
    sick_industrial_accident: "Choroba Priemyselný úraz (LFZ)",
    short_time_work: "Skrátená pracovná doba (Kug)",
    maternity_pay: "Ochrana materstva mzda/zákaz zamestnávania",
    sick_child: "Starostlivosť o choré dieťa s nemocenskou (dennou) dávkou",
    sick_child_no_payment: "Starostlivosť o choré dieťa bez nemocenskej (dennej) dávky",
    vacation_no_payment: "Neplatená dovolenka",
    sick_before_short_time_work: "Nemocenské dávky/choroba pred Kug",
    weather_related_failure: "Zlyhanie v dôsledku poveternostných podmienok",
    sick_short_time_work: "Ochorenie počas Kug",
    sick_no_payment: "Choroba (bez pokračovania vyplácania mzdy)",
    company_vacation: "Firemné dovolenky",
    meals_14_euro: "Malý príspevok na stravovanie",
    meals_28_euro: "Veľký príspevok na stravovanie"
  },
  image_editor: {
    font_size: "Veľkosť písma",
    stroke_width: "Šírka čiary",
    stroke_color: "Farba čiary",
    text_color: "Farba písma",
    rotate_left: "Otočte sa doľava",
    rotate_right: "Otočte sa doprava",
    flip_horizontal: "Zrkadlo vo vodorovnej polohe",
    flip_vertical: "Zrkadlo na výšku"
  },
  travel_log: {
    method_of_transportation: "Dopravné prostriedky",
    company_car: "Firemné vozidlo",
    private_car: "Súkromné auto",
    rental_car: "Prenájom vozidla",
    taxi: 'Taxi',
    public_transportation: "Verejná doprava",
    airplane: "Lietadlo",
    train: "Železničná doprava (diaľková verejná doprava)",
    other: "Iné",
    km_reading_start: "Začiatok najazdených kilometrov",
    km_reading_end: "Koniec najazdených kilometrov",
    net_expenses: "Cestovné výdavky (netto)",
    tax: "Daň z pridanej hodnoty"
  },
  read_in: "Prečítajte si v",
  currency: "Mena",
  reason: "Dôvod",
  label: "Štítok",
  monday: "Pondelok",
  tuesday: "Utorok",
  wednesday: "Streda",
  thursday: "Štvrtok",
  friday: "Piatok",
  saturday: "Sobota",
  sunday: "Nedeľa",
  break_alarm: "Prerušte budík",
  clockin_reminder: "Pripomienka na prihlásenie",
  clockout_reminder: "Pripomienka na odhlásenie"
};